import React from "react";
import "../Footer.css";
import { track } from "../../../services/analytics";

interface SocialMediaProps {
  socialLinks: {
    instagram: string;
    facebook: string;
    youtube: string;
    telegram: string;
    soundcloud: string;
    linkedin: string;
    spotify: string;
  };
}

const SocialMedia: React.FC<SocialMediaProps> = ({ socialLinks }) => {
  const trackSocialMedia = (identificador: string) => {
    track("link_externo_clique", {
      identificador,
      categoria: "rede_social",
    });
  };

  return (
    <div className="footer-social-media">
      <ul className="footer-social-list">
        <li className="footer-social-item">
          <a href={socialLinks.instagram} className="footer-social-link" target="_blank" rel="noopener noreferrer" onClick={() => trackSocialMedia("instagram")}>
            <img
              src={require("../../../assets/img/insta.svg").default}
              alt="Instagram"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.facebook} className="footer-social-link" target="_blank" rel="noopener noreferrer" onClick={() => trackSocialMedia("facebook")}>
            <img
              src={require("../../../assets/img/face.svg").default}
              alt="Facebook"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.youtube} className="footer-social-link" target="_blank" rel="noopener noreferrer" onClick={() => trackSocialMedia("youtube")}>
            <img
              src={require("../../../assets/img/youtube.svg").default}
              alt="YouTube"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.telegram} className="footer-social-link" target="_blank" rel="noopener noreferrer" onClick={() => trackSocialMedia("telegram")}>
            <img
              src={require("../../../assets/img/telegramPB.svg").default}
              alt="Telegram"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.soundcloud} className="footer-social-link" target="_blank" rel="noopener noreferrer" onClick={() => trackSocialMedia("soundcloud")}>
            <img
              src={require("../../../assets/img/soundcloud.svg").default}
              alt="SoundCloud"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.linkedin} className="footer-social-link" target="_blank" rel="noopener noreferrer" onClick={() => trackSocialMedia("linkedin")}>
            <img
              src={require("../../../assets/img/linkedin.svg").default}
              alt="LinkedIn"
              className="footer-social-icon"
            />
          </a>
        </li>
        <li className="footer-social-item">
          <a href={socialLinks.spotify} className="footer-social-link" target="_blank" rel="noopener noreferrer" onClick={() => trackSocialMedia("spotify")}>
            <img
              src={require("../../../assets/img/spotify.svg").default}
              alt="Spotify"
              className="footer-social-icon"
            />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialMedia;
